import { createApi } from '@reduxjs/toolkit/query/react';
import EnhancedBaseQuery from '../../Api/createApiConfig';

const doctorApi = createApi({
    reducerPath: 'doctorApi',
    baseQuery: EnhancedBaseQuery,
    endpoints: () => ({}),
});

const injectedDoctorApi = doctorApi.injectEndpoints({
    endpoints: (builder) => ({
        doctorList: builder.mutation({
            query: (config) => ({
                url: '/doctor/search',
                method: 'POST',
                body: config,
            }),
        }),
        doctorAdd: builder.mutation({
            query: (config) => ({
                url: '/doctor/add',
                method: 'POST',
                body: config,
            }),
        }),
        doctorEdit: builder.mutation({
            query: (config) => ({
                url: 'doctor/edit',
                method: 'POST',
                body: config,
            }),
        }),
        signatureUpload: builder.mutation({
            query: (imageUploadConfig) => ({
                url: '/users/profile/signature/change',
                method: 'POST',
                body: imageUploadConfig,
            }),
        }),
        doctorIdUpload: builder.mutation({
            query: (imageUploadConfig) => ({
                url: '/users/profile/doctorid/upload',
                method: 'POST',
                body: imageUploadConfig,
            }),
        }),
        rppsUpload: builder.mutation({
            query: (imageUploadConfig) => ({
                url: '/users/profile/rpcscode/upload',
                method: 'POST',
                body: imageUploadConfig,
            }),
        }),
    }),
    overrideExisting: false,
});
export const {
    useDoctorListMutation,
    useDoctorAddMutation,
    useDoctorEditMutation,
    useSignatureUploadMutation,
    useDoctorIdUploadMutation,
    useRppsUploadMutation,
} = injectedDoctorApi;
export default doctorApi;
